<template>
  <div class="content "
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}">

    <div class="page-header" :class="{'header-hidden': !isScrollTop}">
      <div class="page-header-img" style="padding-top: 34px;">
        <img :src="require('../../assets/images/notes.png')" width="200"/>
      </div>
      <div class="page-header-content">
        <div class="page-header-title">
          <div>Notes & Comments</div>
          <p>See which donations were made with Notes</p>
        </div>
        <div v-if="donationsState === 'ready'">
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">{{statistic.private_count}}</span>
            <div>Private</div>
          </div>
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">{{statistic.public_count}}</span>
            <div>Public</div>
          </div>
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">{{statistic.total}}</span>
            <div>Total Notes</div>
          </div>
        </div>
      </div>
    </div>
    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :first-donation-date="firstDonationDate"
        v-on:update-date="updateDate"
        v-on:download="download"
        :isSearchBox="false"
    ></reports-menu>

    <div class="px-8 md:px-4 pt-4 d-reports clearfix tab-donations with-header-wrap">
      <div class="d-block shadow-md donations-summary donations-summary-lg">
        <h3 class="title">
          <div class="row">
            <div class="col-xs-4">Notes</div>
            <div class="col-xs-8 text-right "><span>{{selected(startDate, endDate) | intervalLabel}}</span></div>
          </div>
        </h3>

        <div class="contacts-list campaign-donations-list" >
          <div id="c-donations-table_wrapper">

            <el-table
                class="table-extendable"
                :class="{'table-lg-extend': !isScrollTop}"
                style = "width: 100%"
                :default-sort = "sorting"
                :data = "itemsDataPage"
                height="400"
                v-on:sort-change="sortChange"
            >

              <template  slot="empty">
                <div v-if="donationsState === 'ready'" class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/12.svg')" alt="No results">
                  <h3>No Donation Notes in this Timeframe</h3>
                </div>
                <div v-else slot="empty">Loading data...</div>
              </template>

              <el-table-column label="Date & Time"
                               prop="created_at"
                               :sort-orders="['descending', 'ascending']"
                               sortable="custom"
                               width="150"
              >
                <template slot-scope="scope">
                  {{scope.row.created_at | dateFormat('MMM DD, YYYY')}}
                  <div class="info">{{scope.row.created_at | dateFormat('h:mma')}}</div>
                </template>
              </el-table-column>

              <el-table-column label="Name & Email"
                               prop="_full_name"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="200"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span class="show-donor-info"
                          v-on:click.prevent="showDonorSidebar(scope.row.uid)"
                    >{{scope.row.first_name}} {{scope.row.last_name}}</span>
                    <div class="info">{{scope.row.email}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Donation Type"
                               prop="type"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               width="140"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span class="show-donor-info"
                          v-on:click.prevent="showDonorSidebar(scope.row.uid)"
                    >{{scope.row.first_name}} {{scope.row.last_name}}</span>
                    <div class="info">{{scope.row.email}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Amount"
                               prop="amount"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               width="120"
              >
                <template slot-scope="scope">
                  <span>${{scope.row.amount / 100 | formatMoney(0, 9)}}</span>
                  <div class="info">Net Total</div>
                </template>
              </el-table-column>

              <el-table-column label="Campaign"
                               prop="campaign"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="200"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.campaign && scope.row.campaign_id">
                    <router-link :to="{name: 'campaign', params: {campaignId: scope.row.campaign_id}}">
                      {{scope.row.campaign}}
                    </router-link>
                  </div>
                  <div v-else>{{scope.row.campaign || '--'}}</div>
                  <div class="info">Campaign</div>
                </template>
              </el-table-column>

              <el-table-column label="Public"
                               prop="is_note_public"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               width="100"
              >
                <template slot-scope="scope">
                  <span :class="{'txt-green': scope.row.is_note_public, 'txt-red': !scope.row.is_note_public}">
                    {{scope.row.is_note_public? 'Yes': 'No'}}</span>
                  <div class="info">Public</div>
                </template>
              </el-table-column>


              <el-table-column label="Donation Note"
                               prop="note"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="200"
              >
                <template slot-scope="scope">
                  <div class="info" style="max-width: 300px">{{scope.row.note || ''}}</div>
                </template>
              </el-table-column>

            </el-table>

            <el-pagination
                class="text-right"
                background
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :page-size="paginationInfo.pageSize"
                :total="itemsData.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <donor-info v-if="showDonorInfo && showDonorId"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="deleteNoteModal"
           v-on:close-modal="deleteNoteModal = false;"
           :modal-name="'message-turn-off'">
      <div slot="header">
        <div class="info">Delete Note</div>
      </div>
      <div slot="body" class="desc">
        Are you sure you want to delete this note?
        <br><br>
        <em>{{selectedDonation.note}}</em>
      </div>
      <template slot="footer">
        <div>
          <a class="cancel"
             v-on:click.prevent="deleteNoteModal = false"
             href="#">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="deleteNote(selectedDonation);deleteNoteModal = false; "
                  class="btn btn-sm btn-add-to-message btn-delete"
          >Delete Note
          </button>
        </div>
      </template>
    </modal>

    <modal v-if="editNoteModal"
           v-on:close-modal="editNoteModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Note</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <label>Name</label>
          <div class="name"><b>{{selectedDonation.first_name}} {{selectedDonation.last_name}}</b></div>
        </div>

        <div v-if="allCampaigns && allCampaigns.length>0" class="input-control">
          <label for="edit-cmp">Campaign</label>
          <select
              id="edit-cmp"
              class="form-control"
              v-model="editNoteParams.campaign_id"
          >
            <option :value="null">Area of Greatest Need</option>
            <option v-for="campaign in allCampaigns"
                    :key="campaign.id"
                    :value="campaign.id">{{campaign.name}}</option>
          </select>
        </div>

        <div class="input-control">
          <span v-if="editNoteParams.public" class="limit">Public</span>
          <span v-else class="limit limit-red">Private</span>
          <label for="note-text">Note/Comment</label>
          <textarea class="input-sm list-add-text "
                    id="note-text"
                    style="height: auto"
                    v-model="editNoteParams.message"
                    rows="3"
                    placeholder="Note/Comment"></textarea>
        </div>

        <label class="form-switch">
          <input
              type="checkbox"
              v-model="editNoteParams.public"
          > Display this note Publicly
        </label>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editNoteModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editNote(selectedDonation);editNoteModal = false; "
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
import {formatMoney} from '@/utils/utils';
  import ReportsMenu from './menu.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import Modal from '../Modal/index.vue';
  import dataTableMixin from '../Parts/data-table-mixin';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';
  import {mapActions, mapState} from 'vuex';

  const moment = require('moment');

  export default {
    name: 'Reports',
    mixins: [reportsMixin, reportsMenuMixin, dataTableMixin, scrollInfoMixin],
    components: {
      ReportsMenu,
      DonorInfo,
      Modal,
    },
    metaInfo: {
      title: 'Reports - Donation Notes',
    },
    created() {
      this.sorting = {prop: 'created_at', order: 'descending'};
    },
    mounted() {
      this.initScrollInfo(['.el-table--scrollable-y','.el-table__body-wrapper', '.content']);
      this.updateCampaigns({charity_id: this.activeCharityId});
    },
    methods: {
      sortChange(sorting) {
        this.sorting = sorting
      },
      openEditModal(donationInfo){
        this.selectedDonation = donationInfo;

        this.editNoteParams.campaign_id = donationInfo.campaign_id;
        this.editNoteParams.message = donationInfo.note;
        this.editNoteParams.public = donationInfo.is_note_public;

        this.editNoteModal = true;
      },
      deleteNote(donationInfo){
        this.$store.dispatch('donations/editDonationNode', {
          charityId: this.activeCharityId,
          donationId: donationInfo.id,
          params: {note: null}
        })
            .then(() => this.$message('Donation note deleted'))
            .catch(err => alert(err));
      },
      editNote(donationInfo){

        let editParams = {
          "campaign_id": this.editNoteParams.campaign_id
        };
        if (this.editNoteParams.message) {
          editParams['note'] = {
            "message": this.editNoteParams.message,
            "public": this.editNoteParams.public
          };
        } else {
          editParams['note'] = null;
        }

        this.$store.dispatch('donations/editDonationNode', {
          charityId: this.activeCharityId,
          donationId: donationInfo.id,
          params: editParams,
        })
            .then(() => {
              this.$message('Donation note updated')
            })
            .catch(err => alert(err));
      },
      ...mapActions('campaigns', [
        'updateCampaigns',
      ]),
      download(type) {
        const title = `Donation Notes Reports ${this.period.start.format('MMM D YYYY')} - ${this.period.end.format(
          'MMM D YYYY')}`;

        const header = [
          'Date', 'Time', 'First Name', 'Last Name',
          ...(type === 'csv' ? ['Email', 'Donation Type', 'Amount', 'Campaign', 'Public'] : []),
          'Donation Note',
        ];

        const body = this.itemsDataSorted.map(item => {
          const dt = moment(item.created_at);
          return [
            dt.format('MMM D, YYYY'),
            dt.format('h:mma'),
            item.first_name,
            item.last_name,
            ...(type === 'csv' ? [
              item.email,
              this.getDonationTypeTitle(item.type),
              '$' + formatMoney(item.amount / 100, 2, 9),
              item.campaign,
              item.is_note_public ? 'Yes' : 'No',
            ] : []),
            item.note,
          ];
        });

        this.exportData(type, title, header, body, {
          0: {minCellWidth: 30},
          1: {minCellWidth: 20},
          2: {minCellWidth: 40},
          3: {minCellWidth: 40},
        });
      },
    },
    computed: {
      ...mapState({
        allCampaigns: state => state.campaigns.allCampaigns,
        donations: state => state.donations.donations,
        donationsState: state => state.donations.donationsState,
        activeCharityId: state => state.auth.activeCharityId,
      }),
      statistic(){
        let donationsData = this.donationsData.filter(item => item.note);

        return {
          private_count: donationsData.filter(i => !i.is_note_public).length,
          public_count: donationsData.filter(i => i.is_note_public).length,
          total: donationsData.length,
        }
      },
      itemsData() {
        let donationsData = this.donationsData.filter(item => item.note);

        return this.donationsFillCampaigns(donationsData, this.allCampaigns);
      },
    },
    watch: {
      'activeCharityId'() {
        this.updateCampaigns({charity_id: this.activeCharityId});
      },
    },
    data() {
      return {
        deleteNoteModal: false,
        editNoteModal: false,

        selectedDonation: null,
        editNoteParams: {
          campaign_id: null,
          message: '',
          public: false
        },

      }
    },
  };
</script>
